export const ListAnimationMixin = {
  methods: {
    onListAnimationBeforeLeave(el: HTMLElement): void {
      const { marginLeft, marginTop, width, height } = window.getComputedStyle(el)
      el.style.left = `${el.offsetLeft - Number.parseFloat(marginLeft)}px`
      el.style.top = `${el.offsetTop - Number.parseFloat(marginTop)}px`
      el.style.width = width
      el.style.height = height
    }, // https://forum.vuejs.org/t/transition-group-leave-transition-w-position-absolute-jumping-to-top-left-flip/12258/4
  },
}
